/**
 * Earth Diet landing — one-time add to cart for earthdiet ATC buttons.
 */
(function () {
  'use strict';
  if (window.__rncEdCartInit) return;
  window.__rncEdCartInit = true;

  function openDrawer() {
    var api = window.RNC_BUNDLE_GIFTS;
    if (api && typeof api.openCartDrawer === 'function') {
      api.openCartDrawer();
      return;
    }
    // fallback: dispatch common cart open patterns
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    var openers = document.querySelectorAll(
      '[data-cart-toggle], .js-drawer-open-cart, [href="/cart"], .cart-link'
    );
    if (openers.length) {
      try {
        openers[0].click();
      } catch (e) {}
    }
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error((data && (data.description || data.message)) || 'Could not add to cart');
        }
        return data;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ed-atc]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id') || '';
    if (!variantId) {
      window.location.href = '/products/earthdiet';
      return;
    }
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    addVariant(variantId)
      .then(function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'earth_diet_atc', placement: btn.getAttribute('data-ed-atc') });
        } catch (err) {}
        btn.textContent = 'Added ✓';
        openDrawer();
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = orig;
        }, 2000);
      });
  });
})();
